import Link from "next/link";

function ProfileLink({
  children,
  className,
  name,
}: {
  children: React.ReactNode;
  className?: React.ComponentProps<"div">["className"];
  name: string;
}) {
  // const handleRightClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  //   if (e.type === "contextmenu") {
  //     e.preventDefault(); // Prevent default context menu
  //     const newTab = window.open("/profile?user=" + name, "_blank");
  //     if (newTab) newTab.focus(); // Open in a new tab and focus
  //   }
  // };
  return (
    <Link
      href={"/profile?user=" + name}
      // onContextMenu={handleRightClick}
      className={className}
    >
      {children}
    </Link>
  );
}

export default ProfileLink;
